export default __webpack_public_path__ + "static/media/Dependability.267b0be9.svg";